import { render, staticRenderFns } from "./ModalContacto.vue?vue&type=template&id=71601049&scoped=true"
import script from "./ModalContacto.vue?vue&type=script&lang=js"
export * from "./ModalContacto.vue?vue&type=script&lang=js"
import style0 from "./ModalContacto.vue?vue&type=style&index=0&id=71601049&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71601049",
  null
  
)

export default component.exports